import * as yup from 'yup';

export const WizardChecklistValidationScheme = yup.object().shape({
    SchemeName: yup.string().required("Checklist name must be provided"),
    Chapters: yup.array().of(
        yup.object().shape({
            FieldType: yup.number(),
            SelectedBody: yup.boolean(),
        })
    ).compact((x) => !x.SelectedBody).required("You must provide a table")
})